import React from 'react'
import { Badge, Icon } from 'labguard-cdk'
import { useQuery } from 'react-apollo'
import gql from 'graphql-tag'
import { SystemAlarmsIcon } from 'src/components/common'
import { usePollingQuery } from 'src/hooks'

const query = gql`
  query systemAlarmsIcon {
    lastSystemAlarm {
      id
      startDate
      type {
        id
        key
        criticality
        color @client
      }
    }
  }
`

export const lastViewedSystemAlarmsDateQuery = gql`
  query lastViewedSystemAlarmsDate {
    lastViewedSystemAlarmsDate
  }
`

const SystemAlarmsIconBadge = () => {
  // get last system alarm
  const { data: { lastSystemAlarm } = {} } = usePollingQuery(query)

  // get last consultation date
  const { data: { lastViewedSystemAlarmsDate } = {} } = useQuery(lastViewedSystemAlarmsDateQuery)

  return (
    <Badge
      visible={
        !!lastSystemAlarm &&
        (!lastViewedSystemAlarmsDate || new Date(lastViewedSystemAlarmsDate) < lastSystemAlarm.startDate)
      }
      color={lastSystemAlarm && lastSystemAlarm.type.color}
      size=".5rem"
      position={{ top: '-0.25rem', right: '-0.25rem' }}
    >
      <Icon size="lg" icon={SystemAlarmsIcon} />
    </Badge>
  )
}

export default SystemAlarmsIconBadge
